<template>
  <div>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="6" class="my-0 py-0">
            <div class="d-flex grow flex-wrap ml-2">
              <div
                class="font-weight-regular headline text-decoration-underline text-capitalize"
              >
                Curriculum CMS -
                {{ parentFolderData ? parentFolderData.folderName.name : '' }}
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <a @click="$router.back()">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </a>
        </v-card-actions>
        <v-dialog
          v-model="renameModal"
          persistent
          width="500"
          :active="renameModal"
          :on-cancel="
            () => {
              renameModal = false
            }
          "
        >
          <form action="modal-card-body" @submit.prevent="renameNow">
            <v-card>
              <v-toolbar dark color="darkblue">
                <v-toolbar-title
                  >Rename folder :<i>{{ oldName }}</i></v-toolbar-title
                >
              </v-toolbar>
              <v-card-text>
                <label class="label">
                  New Name
                  <span class="requir has-text-danger">*</span>
                </label>
                <v-text-field
                  label="Enter valid character"
                  v-model.trim="newName"
                  maxlength="100"
                >
                </v-text-field>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn class="button" @click="renameModal = false"
                  >Cancel</v-btn
                >
                <span class="v-btn__content"
                  ><input type="submit" class="button" value="Rename"
                /></span>
              </v-card-actions>
            </v-card>
          </form>
        </v-dialog>
        <v-dialog
          v-model="addModalOk"
          :width="isUpload ? '800px' : '800px'"
          :active="addModalOk"
          :on-cancel="
            () => {
              ;(addModalOk = false),
                (folderName = ''),
                (selectedClassID = ''),
                (dropFile = [])
            }
          "
        >
          <div v-if="isUpload">
            <form action="modal-card-body">
              <v-card width="800px">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <label class="label">
                        {{ inputTitle }}
                        <span class="requir has-text-danger">*</span>
                      </label>
                      <span class="has-text-danger"
                        >Allowed file's: .pdf, .jpg, .png, .jpeg
                      </span>
                      <span class="has-text-danger"
                        >Max file size: 20MB each</span
                      >
                      <span class="has-text-danger"
                        >File's that are not supported will be removed
                        automatically!</span
                      >
                    </v-col>
                    <v-col cols="12">
                      <v-file-input
                        label="Click to upload"
                        clear-icon="mdi-close"
                        multiple
                        required
                        outlined
                        placeholder="Click to upload"
                        v-model="dropFile"
                        @input="onFilechange()"
                      ></v-file-input>
                      <span v-if="dropFile.length > 0">
                        <div class="tags">
                          <span
                            class="tag is-primary"
                            v-for="(file, i) in dropFile"
                            :key="i"
                          >
                            {{ file.name }}
                            <button
                              class="delete is-small"
                              type="button"
                              @click="deleteDropFile(i)"
                            ></button>
                          </span>
                        </div>
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    @click="
                      () => {
                        ;(addModalOk = false), (dropFile = [])
                      }
                    "
                  >
                    Close
                  </v-btn>
                  <v-btn color="primary" @click="uploadNow">Upload</v-btn>
                </v-card-actions>
              </v-card>
            </form>
          </div>
          <div v-else>
            <form action="modal-card-body" @submit.prevent="addFolder">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col :cols="6" v-if="!parentFolderId">
                      <label class="label">Class Group</label>
                      <v-autocomplete
                        outlined
                        placeholder="--Select--"
                        name="classSelect"
                        v-model="selectedClassID"
                        required
                        item-value="id"
                        :items="classes"
                        key="id"
                        :item-text="(item) => item.name"
                        hide-details
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="!this.createWeekFolder"
                      :cols="!parentFolderId ? '6' : '12'"
                    >
                      <label class="label">Folder Name</label>
                      <v-text-field
                        placeholder="Enter Name"
                        hide-details
                        outlined
                        v-model.trim="folderName"
                        class="pa-0 pb-0 mb-0 folderItem"
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col v-else>
                      <label class="label">Select Week</label>

                      <v-autocomplete
                        key="id"
                        :items="getWeekWiseValue"
                        placeholder="Select Week"
                        v-model="folderName"
                        required
                        item-text="name"
                        item-value="name"
                        :hide-details="true"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" v-if="!parentFolderId">
                      <label class="label"
                        >Select Academic Year
                        <span class="has-text-danger">*</span></label
                      >
                      <v-autocomplete
                        key="id"
                        :items="academicYears"
                        v-model="academicYearIDs"
                        item-text="academicYear"
                        item-value="id"
                        multiple
                        small-chips
                      >
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12">
                      <label class="label"
                        >Select Franchisee
                        <span class="has-text-danger">*</span></label
                      >
                      <v-checkbox
                        v-model="flag"
                        @change="allFranchisee"
                        label="All Franchisee"
                      ></v-checkbox>
                      <div class="control">
                        <span class="select is-fullwidth">
                          <multiselect
                            class="overflowmultiselect2"
                            label="companyName"
                            track-by="companyName"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            :preselect-first="false"
                            :multiple="true"
                            :options="FranchiseeArr"
                            v-model="selectedFranchisee"
                            required
                          >
                          </multiselect>
                          <h1>
                            NOTE - If no selection is done then bydefault it
                            will apply to all franchisee.
                          </h1>
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <br /><br />
                <v-card-actions class="justify-end">
                  <v-btn
                    @click="
                      () => {
                        ;(addModalOk = false),
                          (folderName = ''),
                          (selectedClassID = ''),
                          (academicYearIDs = ''),
                          (selectedFranchisee = '')
                      }
                    "
                  >
                    Close</v-btn
                  >
                  <!-- <v-btn color="primary" @click="addFolder">Create</v-btn> --><span
                    class="v-btn__content"
                    ><input type="submit" class="button primary" value="Create"
                  /></span>
                </v-card-actions>
              </v-card>
            </form>
          </div>
        </v-dialog>
        <!-- <section> -->
        <card-component>
          <div
            class="level"
            v-show="
              !parentFolderData ||
              (parentFolderData && parentFolderData.nameType !== week)
            "
          >
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle">Folders</p>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item" v-if="isWrite && !parentFolderId">
                <router-link slot="right" :to="{ name: 'themeAndSkillsList' }">
                  <v-btn color="primary" small right>Theme and Skills </v-btn>
                </router-link>
              </div>
              <div class="level-item">
                <v-btn
                  @click="modalOpen"
                  color="primary"
                  small
                  right
                  title="Add New Folder"
                >
                  <v-icon>mdi-plus</v-icon>Add New Folder
                </v-btn>
              </div>
            </div>
          </div>
          <hr />
          <v-row v-if="foldersArr.length > 0">
            <v-col
              v-for="folder in foldersArr"
              :key="folder.id"
              cols="12"
              lg="2"
            >
              <template
                v-if="
                  !parentFolderData ||
                  (parentFolderData && parentFolderData.nameType !== week)
                "
              >
                <v-card
                  v-if="foldersArr.length > 0"
                  color="orange"
                  class="rounded-lg mx-auto pl-1"
                  elevation="2"
                  @click="getFolder(folder.id, null, folder.id)"
                >
                  <div
                    class="d-flex flex-no-wrap justify-space-between fixed-height"
                    style="background-color: white"
                  >
                    <div>
                      <v-card-title class="text-h5 black--text">
                        <span>
                          <v-icon color="gray" x-large
                            >mdi-folder-outline</v-icon
                          >
                        </span>
                        <v-menu bottom left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              black
                              icon
                              v-bind="attrs"
                              v-on="on"
                              absolute
                              top
                              right
                            >
                              <v-icon color="gray">mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item link>
                              <v-list-item-title
                                v-if="modules.DeleteFolder"
                                aria-role="listitem"
                                @click="deleteFolder(folder.id)"
                                >Delete</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item v-if="!isMain" link>
                              <v-list-item-title
                                v-if="modules.RenameFolder && !isMain"
                                aria-role="listitem"
                                @click="
                                  rename(folder.id, folder.folderName.name)
                                "
                                >Rename
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-card-title>
                      <v-card-subtitle>
                        <div class="shortFoldername">
                          {{ folder.folderName.name }}
                        </div>
                      </v-card-subtitle>
                    </div>
                  </div>
                </v-card>
                <p v-else>No folders here!!</p>
              </template>
            </v-col>
          </v-row>
          <template
            v-if="parentFolderData && parentFolderData.nameType === week"
          >
            <v-card>
              <v-card-component>
                <v-card-title>
                  <v-icon color="primary" elevation="1" left
                    >mdi-library-books</v-icon
                  >
                  <span v-if="themeName"
                    >{{ themeName }} (Class Time-
                    {{ totalClassTime }} hours)</span
                  >
                </v-card-title>
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp"
                  elevation="1"
                  color="success"
                  absolute
                  right
                  top
                  @click="isUploadWeekGlance = true"
                >
                  <v-icon color="primary" elevation="1" left>mdi-upload</v-icon>
                  Upload Week Glance
                </v-btn>
                <v-data-table
                  item-key="name"
                  :headers="headers"
                  :items="weekScheduleList"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:item.DAY_1="{ item }">
                    <router-link
                      v-if="
                        item.DAY_1.title &&
                        item.DAY_1.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_1.id }
                      }"
                    >
                      {{ item.DAY_1.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_2="{ item }">
                    <router-link
                      v-if="
                        item.DAY_2.title &&
                        item.DAY_2.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_2.id }
                      }"
                    >
                      {{ item.DAY_2.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_3="{ item }">
                    <router-link
                      v-if="
                        item.DAY_3.title &&
                        item.DAY_3.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_3.id }
                      }"
                    >
                      {{ item.DAY_3.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_4="{ item }">
                    <router-link
                      v-if="
                        item.DAY_4.title &&
                        item.DAY_4.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_4.id }
                      }"
                    >
                      {{ item.DAY_4.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_5="{ item }">
                    <router-link
                      v-if="
                        item.DAY_5.title &&
                        item.DAY_5.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_5.id }
                      }"
                    >
                      {{ item.DAY_5.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_6="{ item }">
                    <router-link
                      v-if="
                        item.DAY_6.title &&
                        item.DAY_6.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_6.id }
                      }"
                    >
                      {{ item.DAY_6.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                </v-data-table>
              </v-card-component>
            </v-card>
          </template>
          <hr />
          <hr v-if="!isMain" />
        </card-component>
      </v-card>
      <v-dialog
        v-model="isUploadWeekGlance"
        persistent
        width="80%"
        :active="isUploadWeekGlance"
        :on-cancel="
          () => {
            isUploadWeekGlance = false
          }
        "
      >
        <form action="modal-card-body" @submit.prevent="saveWeekTheme">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title
                >Upload Week Glance:
                {{ parentFolderData ? parentFolderData.folderName.name : '' }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col class="mt-2" cols="12" sm="5">
                  <label class="font-weight-medium body-2">
                    Week Theme:
                    <span class="requir error--text">*</span>
                  </label>
                  <v-text-field
                    required
                    v-model.trim="weekTheme"
                    placeholder="Enter Week Theme"
                  ></v-text-field>
                </v-col>
                <v-col class="mt-2" cols="12" sm="3">
                  <label class="font-weight-medium body-2">
                    Class Time (In Minutes):
                    <span class="requir error--text">*</span>
                  </label>
                  <v-text-field
                    type="Number"
                    min="1"
                    max="600"
                    required
                    v-model.trim="classTime"
                    placeholder="Class Time"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <label class="font-weight-medium body-2">
                    Download reference file: <br />
                  </label>
                  <v-btn
                    color="success"
                    href="https://intellitots.s3.ap-south-1.amazonaws.com/DamagedProducts.csv"
                  >
                    Download
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5">
                  <b>File must contain: <br /></b>
                  <ul>
                    <li>Session (Name of the sesssion)</li>
                    <li>Time (Session time in minutes)</li>
                    <li>Day_1</li>
                    <li>Day_2</li>
                    <li>Day_3</li>
                    <li>Day_4</li>
                    <li>Day_5</li>
                    <li>Day_6</li>
                  </ul>
                </v-col>
                <v-col cols="12" sm="6">
                  <label class="font-weight-medium body-2">
                    Upload file:
                    <span class="requir has-text-danger"
                      >* (Accepts: .csv)</span
                    >
                    <span class="requir error--text">*</span>
                  </label>
                  <v-file-input
                    @change="csvToJsonInput(weekGlanceFile)"
                    v-model="weekGlanceFile"
                    placeholder="Click here to Upload File"
                    :messages="['(max file size allowed 5MB)']"
                    accept=".csv"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-card-text>
            <v-row>
              <v-col cols="12" sm="12">
                <v-data-table
                  v-if="jsonData.length"
                  item-key="name"
                  :headers="JSONDataHeaders"
                  :items="jsonData"
                  disable-pagination
                  hide-default-footer
                >
                </v-data-table>
              </v-col>
            </v-row>
            <v-card-actions class="d-flex justify-end">
              <v-btn align="right" color="error" @click="resetData"
                >Cancel</v-btn
              >
              <v-btn align="right" color="primary" type="submit"
                >Upload File</v-btn
              >
            </v-card-actions>
          </v-card>
        </form>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import csvtojsonV2 from 'csvtojson'
export default {
  name: 'curriculum',
  components: {
    CardComponent,
    VCardComponent,
    Multiselect
  },
  props: ['folderId'],
  data () {
    return {
      modules: {
        themeAndSkills: this.checkModuleAccess('ThemeAndSkills')
      },
      isSuperAdmin: false,
      isUploadWeekGlance: false,
      classTime: null,
      totalClassTime: null,
      weekGlanceFile: null,
      selectedClassID: '',
      getList: [],
      academicYears: [],
      isLoading: false,
      classes: [],
      addModalOk: false,
      folderName: '',
      franchiseeID: '',
      academicYearIDs: [],
      foldersArr: [],
      isMain: true,
      parentFolderId: '',
      isUpload: false,
      weekTheme: null,
      fileName: '',
      dropFile: [],
      inputTitle: "Select file('s)",
      renameModal: false,
      newName: '',
      oldName: '',
      renameId: '',
      idForUpload: '',
      files: [],
      flag: '',
      loadingComponent: null,
      isWrite: false,
      selectedFranchisee: [],
      FranchiseeArr: [],
      parentFolderData: null,
      subFolderFr: true,
      inProgress: false,
      nameType: '',
      createWeekFolder: false,
      jsonData: [],
      week: 'WEEK',
      allowedFiles: ['pdf', 'jpg', 'png', 'jpeg'],
      weekScheduleList: [],
      theme: '',
      dayArray: {},
      newData: [],
      item: [],
      currentAcademicYear: null,
      themeName: null,
      search: '',
      JSONDataHeaders: [
        {
          text: 'Session',
          value: 'Session',
          sortable: false
        },
        {
          text: 'Time',
          value: 'Time',
          sortable: false
        },
        {
          text: 'Day_1',
          value: 'Day_1',
          sortable: false
        },
        {
          text: 'Day_2',
          value: 'Day_2',
          sortable: false
        },
        {
          text: 'Day_3',
          value: 'Day_3',
          sortable: false
        },
        {
          text: 'Day_4',
          value: 'Day_4',
          sortable: false
        },
        {
          text: 'Day_5',
          value: 'Day_5',
          sortable: false
        },
        {
          text: 'Day_6',
          value: 'Day_6',
          sortable: false
        }
      ],
      headers: [
        {
          text: 'Session',
          name: 'Session',
          value: 'Session',
          align: 'center',
          maxWidth: '10%',
          sortable: false
        },
        {
          text: 'Time (In Minutes)',
          name: 'Time',
          value: 'Time',
          align: 'center',
          maxWidth: '10%',
          sortable: false
        },
        {
          text: 'DAY 1',
          name: 'DAY_1',
          value: 'DAY_1',
          align: 'center',
          maxWidth: '20%',
          sortable: false
        },
        {
          text: 'DAY 2',
          name: 'DAY_2',
          value: 'DAY_2',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 3',
          name: 'DAY_3',
          value: 'DAY_3',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 4',
          name: 'DAY_4',
          value: 'DAY_4',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 5',
          name: 'DAY_5',
          value: 'DAY_5',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 6',
          name: 'DAY_6',
          value: 'DAY_6',
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  created: async function () {
    this.isSuperAdmin = Utils.helper.isSuperAdmin()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    for (let day of this.headers) {
      let dayName = day.text.replace(' ', '_')
      this.dayArray[dayName] = {
        folderID: this.folderId,
        dayID: dayName,
        day: day.text
      }
    }

    this.currentAcademicYear = await Utils.getCurrentAcademicYear()
    this.academicYear = this.academicYears.find((y) => {
      return y.academicYear.trim() === this.currentAcademicYear.trim()
    })
    this.academicYearID = this.academicYear ? this.academicYear.id : ''
    if (this.folderId) {
      this.getFolder(this.folderId, 'fromWatch')
    } else {
      await this.onFranchiseeChange()
    }
    await this.getAcademicYears()
    await this.getFranchiseeList()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),

    getWeekWiseValue () {
      let temp = []
      for (let i = 1; i <= 54; i++) {
        temp.push({ id: i, name: `WEEK ${i}` })
      }
      return temp
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      this.files = []
      this.foldersArr = []
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      this.files = []
      this.foldersArr = []
      await this.onFranchiseeChange()
    },
    folderId (val) {
      this.files = []
      this.foldersArr = []
      this.getFolder(val, 'fromWatch')
    }
  },
  methods: {
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows

        this.currentAcademicYear = await Utils.getCurrentAcademicYear()
        this.academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === this.currentAcademicYear.trim()
        })
        this.academicYearID = this.academicYear ? this.academicYear.id : ''
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    deleteFile: async function (id) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/franchisee/delete-video/${id}`)
        this.okMsg('File Deleted successfully!')
        this.onFranchiseeChange()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteFolder: async function (id) {
      try {
        this.isLoading = true
        await http.get(`${constants.API_URL}/api/curriculum_cms/status/${id}`)
        this.okMsg('Folder Deleted successfully!')
        this.onFranchiseeChange()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    fileOpen: async function (path) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${path}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    renameNow: async function () {
      if (!this.newName) {
        this.errMsg('Name cannot be empty!')
        return false
      }
      try {
        await http.post(
          `${constants.API_URL}/api/curriculum_cms/rename/${this.renameId}`,
          {
            name: this.newName,
            academicYearID: this.academicYearID
          }
        )
        this.okMsg('Folder Renamed!!')
        this.renameModal = false
        this.newName = ''
        this.getFolder(this.folderId, 'fromWatch')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    rename (id, name) {
      this.renameModal = true
      this.renameId = id
      this.oldName = name
    },
    uploadNow: async function () {
      this.loadingComponent = this.$buefy.loading.open()
      let formData = new FormData()
      formData.append('type', 'EDUCATION')
      formData.append('folderID', this.folderId)

      for (let i in this.dropFile) {
        formData.append('file', this.dropFile[i])
      }

      try {
        let res = await http.post(
          `${constants.API_URL}/api/academic/upload-data`,
          formData
        )

        res.data.map((a) => {
          if (a.isBoom && a.output.payload.statusCode === 417) {
            this.errMsg(a.output.payload.message)
          } else {
            this.okMsg(`"${a.name}" uploaded successfully`)
          }
        })

        this.addModalOk = false
        this.getFolder(this.folderId, 'fromWatch')
        this.dropFile = []
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
      this.loadingComponent.close()
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    },
    addFolder: async function () {
      let formData = {}

      if (!this.folderName) {
        this.errMsg('Folder name cannot be empty!')
        return false
      }
      if (this.folderName !== '') {
        formData.name = this.folderName
      }
      formData.academicYearID = this.academicYearIDs
      formData.franchiseeID =
        this.selectedFranchisee.length > 0
          ? this.selectedFranchisee.map((obj) => obj.id)
          : null
      formData.classID = 0

      if (this.isMain) {
        if (!this.selectedClassID) {
          this.errMsg('Kindly select class!')
          return false
        }
        formData.classID = this.selectedClassID
      } else if (this.parentFolderId) {
        formData.folderMapID = this.parentFolderId
      }

      try {
        this.loadingComponent = this.$buefy.loading.open()
        let res = await http.post(
          `${constants.API_URL}/api/curriculum_cms`,
          formData
        )
        if (res.data === 'Folder Already Exist.') {
          this.errMsg(res.data)
        } else {
          this.okMsg(res.data)
        }
        this.addModalOk = false
        this.folderName = ''
        this.selectedClassID = ''
        this.selectedFranchisee = ''
        this.loadingComponent.close()

        this.getFolder(
          this.parentFolderId ? this.parentFolderId : null,
          'fromWatch'
        )
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    csvToJsonInput: async function (files) {
      const loadingComponent = this.$buefy.loading.open()
      try {
        // console.log('csvToJsonInput called')
        if (files.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = files
        this.readerFile(file, async (e) => {
          try {
            this.jsonData = await csvtojsonV2().fromString(e.target.result)
            if (!this.jsonData[0].Session || !this.jsonData[0].Time) {
              this.jsonData = []
              this.weekGlanceFile = null
              return this.errMsg('Inavlid File Data')
            }
            console.log('this.jsonData', this.jsonData)
          } catch (e) {
            this.jsonData = ''
            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            return this.errMsg(errorMessage)
          }
        })
        this.flag = true
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('e :', errorMessage)
      } finally {
        loadingComponent.close()
      }
    },
    readerFile: function (file, onLoadCallback) {
      let reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    getFolder: async function (parentId, fromWatch, uploadWalaId) {
      const loadingComponent = this.$buefy.loading.open()
      let url = ''
      if (parentId) {
        // get subfolders
        url = `${constants.API_URL}/api/curriculum_cms?folderMapID=${parentId}`
        if (!fromWatch) {
          this.$router.push({
            name: 'folder-cms',
            params: { folderId: parentId }
          })
        }
      } else {
        url = `${constants.API_URL}/api/curriculum_cms?academicYearID=${this.academicYearID}`
      }
      if (url) {
        try {
          const { data } = await http.get(url)

          this.foldersArr = data.folders
          this.parentFolderData = data.parentFolderData
          this.files = data.files
          this.isMain = !parentId
          this.parentFolderId = parentId
          if (this.parentFolderData) {
            if (this.parentFolderData.position >= 1) {
              this.createWeekFolder = true
            }
            this.nameType = this.parentFolderData.nameType
          }
          if (this.nameType === this.week) {
            await this.getWeekScheduleList()
            await this.modifyHeaders()
          }
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          // this.errMsg(errorMessage)
          console.log(errorMessage)
        }
      }
      loadingComponent.close()
    },
    saveWeekTheme: async function () {
      const loadingComponent = this.$buefy.loading.open()
      try {
        if (!this.weekTheme) {
          return this.errMsg('Week Theme is required!')
        }
        if (!this.classTime) {
          return this.errMsg('Class time is required!')
        }
        if (!this.jsonData.length) {
          return this.errMsg('Please upload file')
        }
        for (let obj of this.jsonData) {
          if (!Number(obj.Time)) {
            throw new Error('Session Time must be number!')
          }
          if (obj.Session === '' || obj.Session == null) {
            throw new Error('Session name is required for all rows!')
          }
        }
        const payload = {
          folderMapID: this.parentFolderId,
          themeName: this.weekTheme,
          classTime: this.classTime,
          scheduleData: this.jsonData
        }
        const response = await http.post(
          `${constants.API_URL}/api/curriculum_cms/weekschedule/bulk-upload`,
          payload
        )
        await this.resetData()
        await this.getWeekScheduleList()
        console.log(response)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        loadingComponent.close()
      }
    },
    modalOpen (mode) {
      this.addModalOk = true
      this.isUpload = mode === 'upload'
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/student/getclass-group`
        )
        this.isLoading = false
        data = _.filter(data, (e) => {
          return (
            e.type === constants.ClassGroupTypes.curriculum_cms &&
            e.isActive === true
          )
        })
        this.classes = data
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassListByGroupID: async function (objClassID) {
      this.hasClicked = true
      this.loader = true
      this.getList = []
      this.mappingData = []
      if (objClassID) {
        let classGroupID = objClassID
        try {
          const { data } = await http.get(
            `${constants.API_URL}/api/student/get-selected-classgroup-mapping/${classGroupID}`
          )
          this.mappingData = data
          let selectedClassObj = []
          if (this.mappingData) {
            const objectArray = Object.entries(this.mappingData)
            objectArray.forEach(([key, value]) => {
              value.studentClasses.map(function (k) {
                selectedClassObj.push(k.name)
              })
            })
            this.getList = selectedClassObj.join(', ')
          }
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.errMsg(
            `Error While getting Class Group Mapping: ${errorMessage}`
          )
        }
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee/active`)
        let data = res.data
        this.FranchiseeArr = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    resetData: async function () {
      this.weekTheme = null
      this.isUploadWeekGlance = false
      this.classTime = null
      this.weekGlanceFile = null
      this.jsonData = []
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        console.log('this.academicYear', this.academicYear)
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        await this.getClassList()
        this.currentPage = 1
        this.inProgress = false
      }
      this.getFolder(this.folderId, 'fromWatch')
    },
    modifyHeaders: async function () {
      let res = await http.get(
        `${constants.API_URL}/api/curriculum_cms/get-week/${this.folderId}`
      )
      if (res.data.success !== 200) {
        return
      }
      if (!res.data.weekAtGlance.length) {
        return
      }
      res.data = res.data.weekAtGlance.sort(function (a, b) {
        return a.dayName.localeCompare(b.dayName)
      })
      res.data.forEach((item, index) => {
        this.headers[index].id = item.id
      })
    },
    getWeekScheduleList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-week/${this.parentFolderId}`
        )
        if (res.data.success !== 200 || !res.data.weekAtGlance.length) {
          this.weekScheduleList = []
          this.themeName = null
          this.totalClassTime = null
          return
        }
        this.themeName = ''
        let days = res.data.weekAtGlance

        this.themeName = days[0].themeName || null
        this.totalClassTime = days[0].classTime || null
        if (this.totalClassTime) {
          this.totalClassTime = Number(this.totalClassTime / 60).toFixed(0)
        }
        days = days.sort(function (a, b) {
          return a.dayName.localeCompare(b.dayName)
        })
        console.log(days)
        let row = {}
        row['Time'] = []
        row['Session'] = []
        let daysArray = []

        for (let day of res.data.weekAtGlance) {
          day.weekDay = _.orderBy(day.weekDay, 'position', 'asc')
          daysArray.push(day.dayName)
          row[day.dayName] = day.weekDay
        }
        let finalData = []
        let TimeArray = row[daysArray[0]].map((obj) => obj.themeTime)
        let sessionArray = row[daysArray[0]].map((obj) => obj.theme)
        for (let i in TimeArray) {
          let obj = {}
          obj.Time = TimeArray[i]
          obj.Session = sessionArray[i]
          for (let day of daysArray) {
            let dayName = day.split(' ').join('_').toUpperCase()
            console.log(day)
            obj[dayName] = row[day][i]
          }
          finalData.push(Object.assign({}, obj))
        }
        this.weekScheduleList = finalData
        console.log('this.weekScheduleList', this.weekScheduleList)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    // Added method
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },

    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flag === true) {
        this.FranchiseeArr.forEach((Obj) => {
          franchiseeArray.push(Obj)
        })
        this.flag = true
      }
      this.selectedFranchisee = franchiseeArray
    }
  }
}
</script>
<style scoped>
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
.v-input__control .v-text-field__details {
  margin-bottom: 0px !important;
}
.tile.is-child {
  border: 1px solid #ff000059;
}
.fol-name {
  overflow-wrap: break-word;
}
.foldr {
  cursor: pointer;
}
.is-justify-content-space-between {
  justify-content: space-between;
}
/* .shortFoldername {
  width: 155px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
.shortFoldername div {
  padding: 0 20px;
}
@media (min-width: 375px) and (max-width: 477px) {
  .v-btn--absolute.v-btn--right.v-btn--top {
    margin-top: 0px !important;
  }
}
@media screen and (min-width: 800px) {
  .fixed-height {
    height: 100px;
  }
  .shortFoldername {
    width: 155px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .shortFoldername:hover {
    background: #eaeaea;
    border: 1px solid #ccc;
    position: relative;
    z-index: 9;
    left: 0;
    white-space: initial;
    min-height: 50px;
    min-width: 100px;
    padding: 5px;
    border-radius: 4px;
  }
}
@media screen and (max-width: 600px) {
  .shortFoldername {
    display: block;
    position: relative;
    /* width: 26px; */
    word-break: break-all;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
